import { useAuthorizedDeviceStore } from "~/stores/use-authorieze-device-store";

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return; // Omitir en SSR

  const authorizedDevice = useAuthorizedDeviceStore();

  authorizedDevice.loadUserFromLocalStorage();

  const user = authorizedDevice.user;
  const isVerified = user?.authorized_device === true;
  const hasUser = !!user;

  // if (!hasUser) {
  //   return navigateTo("/");
  // }

  if (hasUser && isVerified && to.path === "/verificacion-dos-pasos") {
    return navigateTo("/");
  }

  // if (hasUser && !isVerified && to.path !== "/verificacion-dos-pasos") {
  //   return navigateTo("/verificacion-dos-pasos");
  // }

  // if (hasUser && !isVerified && to.path === "/") {
  //   return navigateTo("/verificacion-dos-pasos");
  // }
});
